import Api from 'app/lib/api'
import { parseError } from 'app/lib/services/ErrorService'

export function complainInvoice(id: number, payload: unknown): Promise<void> {
  return new Promise((resolve, reject) => {
    Api.post(`/invoices/${id}/complain`, payload)
      .then(() => {
        resolve()
      })
      .catch((error) => {
        reject(parseError(error))
      })
  })
}
